<template lang="pug">
  v-tooltip(:disabled="!value" top)
    template(v-slot:activator="activator")
      .d-inline-block(v-on="activator.on")
        slot(
          v-bind="activator"
        )
    slot(name="reason")
      span {{ reason }}
</template>

<script>
export default {
  name: 'DisabledWrap',
  props: {
    // show tooltip when value is false
    value: { type: Boolean, default: false },
    reason: { type: String, default: 'Неактивно' },
  },
};
</script>
